package dev.tonholo.s2c.website.theme.typography

// Font families — single source of truth
object FontFamilies {
    val sans = arrayOf("Space Grotesk", "sans-serif")
    val mono = arrayOf("JetBrains Mono", "monospace")
}
